<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="md"
		:title="$t('users.resetPassword')"
	>
		<b-form @submit="onSubmit">
			<b-form-group :label="$t('users.newPassword')">
				<b-form-input
					v-model="model.password"
					type="password"
					required
				/>
			</b-form-group>
			<b-form-group :label="$t('users.repeatPassword')">
				<b-form-input
					v-model="model.repeatPassword"
					type="password"
					required
				/>
			</b-form-group>
			<hr />
			<div class="text-center">
				<b-button
					v-if="!loadingUpdatePass"
					variant="primary"
					type="submit"
					>{{ $t("profile.updatePassword") }}</b-button
				>
				<b-button v-else disabled variant="primary" type="submit"
					><b-spinner small
				/></b-button>
			</div>
		</b-form>
	</b-modal>
</template>

<script>
export default {
	data() {
		return {
			modelId: null,
			loading: false,
			loadingUpdatePass: false,
			model: {
				password: null,
				repeatPassword: null
			}
		};
	},

	methods: {
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
		},
		onSubmit(event) {
			event.preventDefault();
			if (this.model.password === this.model.repeatPassword) {
				this.loading = true;
				this.$root.api
					.post(`users/${this.modelId}/reset-password`, {
						password: this.model.password
					})
					.then(() => {
						this.model.password = "";
						this.model.repeatPassword = "";
						this.loading = false;
						this.$root.showAlert(this.$t("users.updatedPassword"));
						this.$refs["modal-view"].hide();
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.$root.showAlert(this.$t("users.passwordAreDifferent"), {
					variant: "danger"
				});
			}
		}
	}
};
</script>

<style></style>
